import React from "react";
import styles from "./privacyPolicy.module.scss";
import { Heading, Link, Text } from "@radix-ui/themes";

const PrivacyPolicy: React.FC = () => (
  <div className={`container ${styles.privacyPolicyContainer}`}>
    <Heading as="h1" color="blue">
      Privacy Policy
    </Heading>
    <Heading as="h2">A. INTRODUCTION</Heading>
    <Text as="p">
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>{" "}
      recognizes the importance of privacy of its users and also of maintaining
      confidentiality of the information provided by its users as a responsible
      data controller and data processor.
    </Text>
    <Text as="p">
      This Privacy Policy provides for the practices for handling and securing
      user's Personal Information (defined hereunder) by{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>
      .
    </Text>
    <Text as="p">
      This Privacy Policy is applicable to any person ('<strong>User</strong>')
      who purchases, intends to purchase, or inquire about any product(s) or
      service(s) made available by{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>{" "}
      through any of{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide's</strong>
      </Link>
      website, mobile site (collectively referred herein as "
      <strong>Sales Channels</strong>").
    </Text>
    <Text as="p">
      For the purpose of this Privacy Policy, wherever the context so requires
      "you" or "your" shall mean User and the term "we", "us", "our" shall mean{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>
      . For the purpose of this Privacy Policy, Website means the website(s),
      mobile site(s).
    </Text>
    <Text as="p">
      By using or accessing the Website or other Sales Channels, the User hereby
      agrees with the terms of this Privacy Policy and the contents herein. If
      you disagree with this Privacy Policy please do not use or access our
      Website or other Sales Channels.
    </Text>
    <Text as="p">
      This Privacy Policy is an integral part of your User Agreement with{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>{" "}
      and all capitalized terms used, but not otherwise defined herein, shall
      have the respective meanings as ascribed to them in the User Agreement.
    </Text>
    <Heading as="h2">B. USERS OUTSIDE THE GEOGRAPHICAL LIMITS OF INDIA</Heading>
    <Text as="p">
      Please note that the data shared with QuickBusRide shall be primarily
      processed in India and such other jurisdictions.
    </Text>
    <Text as="p">
      If you have any concerns in the processing your data and wish to withdraw
      your consent, you may do so by writing to the following email id:
      admin@quickbusride.in. However, if such processing of data is essential
      for us to be able to provide service to you, then we may not be able to
      serve or confirm your bookings after your withdrawal of consent. For
      instance, if you want to book a bus journey, then certain personal
      information of yours like contact details, gender details etc. may have to
      be shared by us with our bus operator and they may further process this
      information for making suitable arrangements for your journey.
    </Text>
    <Text as="p">
      A withdrawal of consent by you for us to process your information may:
    </Text>
    <ol>
      <li>
        <Text as="p">
          severely inhibit our ability to serve you properly and in such case,
          we may have to refuse the booking altogether, or
        </Text>
      </li>
      <li>
        <Text as="p">
          unreasonably restrict us to service your booking (if a booking is
          already made) which may further affect your trip or may compel us to
          cancel your booking.
        </Text>
      </li>
    </ol>
    <Heading as="h2">
      C. TYPE OF INFORMATION WE COLLECT AND ITS LEGAL BASIS
    </Heading>
    <Text as="p">
      <strong>"Personal Information"</strong> of User shall include the
      information shared by the User and collected by us for the following
      purposes:
    </Text>
    <ol>
      <li>
        <Text as="p">
          <strong>Registration on the Website:</strong> Information which you
          provide while subscribing to or registering on the Website, including
          but not limited to information about your personal identity such as
          name, gender, age etc., your contact details such as your email
          address, telephone (mobile or otherwise) and/or fax numbers. The
          information may also include information such as your banking details
          (including credit/debit card); billing information payment history
          etc. (as shared by you).
        </Text>
      </li>
      <li>
        <Text as="p">
          <strong>Other information:</strong> We many also collect some other
          information and documents including but not limited to:
        </Text>
        <ol>
          <li>
            <Text as="p">
              Transactional history (other than banking details) about your
              e-commerce activities, buying behavior.
            </Text>
          </li>
          <li>
            <Text as="p">
              Your usernames, passwords, email addresses and other
              security-related information used by you in relation to our
              Services.
            </Text>
          </li>
          <li>
            <Text as="p">
              Data either created by you or by a third party and which you wish
              to store on our servers such as image files, documents etc.
            </Text>
          </li>
          <li>
            <Text as="p">
              Information pertaining any other traveler(s) for who you make a
              booking through your registered{" "}
              <Link href="https://quickbusride.in">
                <strong>QuickBusRide</strong>
              </Link>{" "}
              account. In such case, you must confirm and represent that each of
              the other traveler(s) for whom a booking has been made, has agreed
              to have the information shared by you disclosed to us and further
              be shared by us with the concerned service provider(s).
            </Text>
          </li>
        </ol>
      </li>
    </ol>
    <Heading as="h2">D. HOW WE USE YOUR PERSONAL INFORMATION</Heading>
    <Text as="p">
      The Personal Information collected maybe used in the following manner:
    </Text>
    <ol>
      <li>
        <Text as="p">
          <strong>While making a booking:</strong>
        </Text>
        <Text as="p">
          While making a booking, we may use Personal Information including,
          payment details which include cardholder name, credit/debit card
          number (in encrypted form) with expiration date, banking details,
          wallet details etc. as shared and allowed to be stored by you. We may
          also use the information of travelers list as available in or linked
          with your account. This information is presented to the User at the
          time of making a booking to enable you to complete your bookings
          expeditiously.
        </Text>
      </li>
      <li>
        <Text as="p">
          <strong>
            We may also use your Personal Information for several reasons
            including but not limited to:
          </strong>
        </Text>
        <ol>
          <li>
            <Text as="p">keep you informed of the transaction status;</Text>
          </li>
          <li>
            <Text as="p">
              Your usernames, passwords, email addresses and other
              security-related information used by you in relation to our
              Services.
            </Text>
          </li>
          <li>
            <Text as="p">
              send booking confirmations either via SMS or Whatsapp or any other
              messaging service;
            </Text>
          </li>
          <li>
            <Text as="p">send any updates or changes to your booking(s);</Text>
          </li>
          <li>
            <Text as="p">
              allow our admin service to contact you, if necessary;
            </Text>
          </li>
          <li>
            <Text as="p">
              customize the content of our website, mobile site;
            </Text>
          </li>
          <li>
            <Text as="p">
              request for reviews of products or services or any other
              improvements;
            </Text>
          </li>
          <li>
            <Text as="p">send verification message(s) or email(s);</Text>
          </li>
          <li>
            <Text as="p">
              Validate/authenticate your account and to prevent any misuse or
              abuse.
            </Text>
          </li>
        </ol>
      </li>
    </ol>
    <Heading as="h2">E. HOW LONG DO WE KEEP YOUR PERSONAL INFORMATION?</Heading>
    <Text as="p">
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>{" "}
      will retain your Personal Information on its servers for as long as is
      reasonably necessary for the purposes listed in this policy. In some
      circumstances we may retain your Personal Information for longer periods
      of time, for instance where we are required to do so in accordance with
      any legal, regulatory, tax or accounting requirements.
    </Text>
    <Heading as="h2">F. COOKIES AND SESSION DATA</Heading>
    <ol>
      <li>
        <Text as="p">
          <strong>Cookies</strong>
        </Text>
        <Text as="p">
          <Link href="https://quickbusride.in">
            <strong>QuickBusRide</strong>
          </Link>{" "}
          uses cookies to personalize your experience on the Website and the
          advertisements that maybe displayed.{" "}
          <Link href="https://quickbusride.in">
            <strong>QuickBusRide's</strong>
          </Link>
          use of cookies is similar to that of any other reputable online
          companies.
        </Text>
        <Text as="p">
          Cookies are small pieces of information that are stored by your
          browser on your device's hard drive. Cookies allow us to serve you
          better and more efficiently. Cookies also allow ease of access, by
          logging you in without having to type your login name each time (only
          your password is needed); we may also use such cookies to display any
          advertisement(s) to you while you are on the Website.
        </Text>
        <Text as="p">
          A cookie may also be placed by our advertising servers, or third party
          advertising companies. Such cookies are used for purposes of tracking
          the effectiveness of advertising served by us on any website, and also
          to use aggregated statistics about your visits to the Website in order
          to provide advertisements in the Website or any other website about
          services that may be of potential interest to you. The third party
          advertising companies or advertisement providers may also employ
          technology that is used to measure the effectiveness of the
          advertisements. All such information is anonymous. This anonymous
          information is collected through the use of a pixel tag, which is an
          industry standard technology and is used by all major websites. They
          may use this anonymous information about your visits to the Website in
          order to provide advertisements about goods and services of potential
          interest to you. No Personal Information is collected during this
          process. The information so collected during this process, is
          anonymous, and does not link online actions to a User.
        </Text>
        <Text as="p">
          Most web browsers automatically accept cookies. Of course, by changing
          the options on your web browser or using certain software programs,
          you can control how and whether cookies will be accepted by your
          browser.{" "}
          <Link href="https://quickbusride.in">
            <strong>QuickBusRide</strong>
          </Link>{" "}
          supports your right to block any unwanted Internet activity,
          especially that of unscrupulous websites. However, blocking{" "}
          <Link href="https://quickbusride.in">
            <strong>QuickBusRide</strong>
          </Link>{" "}
          cookies may disable certain features on the Website, and may hinder an
          otherwise seamless experience to purchase or use certain services
          available on the Website. Please note that it is possible to block
          cookie activity from certain websites while permitting cookies from
          websites you trust.
        </Text>
      </li>
      <li>
        <Text as="p">
          <strong>Automatic Logging of Session Data:</strong>
        </Text>
        <Text as="p">
          Each time you access the Website your session data gets logged.
          Session data may consist of various aspects like the IP address,
          operating system and type of browser software being used and the
          activities conducted by the User while on the Website. We collect
          session data because it helps us analyze User’s choices, browsing
          pattern including the frequency of visits and duration for which a
          User is logged on. It also helps us diagnose problems with our servers
          and lets us better administer our systems. The aforesaid information
          cannot identify any User personally. However, it may be possible to
          determine a User's Internet Service Provider (ISP), and the
          approximate geographic location of User's point of connectivity
          through the above session data
        </Text>
      </li>
    </ol>
    <Heading as="h2">G. DISCLOSURE OF INFORMATION</Heading>
    <Text as="p">
      In addition to the circumstances described above,{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>{" "}
      may disclose User's Personal Information if required to do so:
    </Text>
    <ol>
      <li>
        <Text as="p">
          by law, required by any enforcement authority for investigation, by
          court order or in reference to any legal process;
        </Text>
      </li>
      <li>
        <Text as="p">to conduct our business;</Text>
      </li>
      <li>
        <Text as="p">
          for regulatory, internal compliance and audit exercise(s)
        </Text>
      </li>
      <li>
        <Text as="p">to secure our systems; or</Text>
      </li>
      <li>
        <Text as="p">
          to enforce or protect our rights or properties of{" "}
          <Link href="https://quickbusride.in">
            <strong>QuickBusRide</strong>
          </Link>
          . or any or all of its affiliates, associates, employees, directors or
          officers or when we have reason to believe that disclosing Personal
          Information of User(s) is necessary to identify, contact or bring
          legal action against someone who may be causing interference with our
          rights or properties, whether intentionally or otherwise, or when
          anyone else could be harmed by such activities.
        </Text>
      </li>
    </ol>
    <Text as="p">
      Such disclosure and storage may take place without your knowledge. In that
      case, we shall not be liable to you or any third party for any damages
      howsoever arising from such disclosure and storage.
    </Text>
    <Heading as="h2">H. HOW WE PROTECT YOUR PERSONAL INFORMATION?</Heading>
    <Text as="p">
      All payments on the Website are secured. This means all Personal
      Information you provide is transmitted using TLS (Transport Layer
      Security) encryption. TLS is a proven coding system that lets your browser
      automatically encrypt, or scramble, data before you send it to us. Website
      has stringent security measures in place to protect the loss, misuse, and
      alteration of the information under our control. Whenever you change or
      access your account information, we offer the use of a secure server. Once
      your information is in our possession we adhere to strict security
      guidelines, protecting it against unauthorized access.
    </Text>
    <Heading as="h2">I. WITHDRAWAL OF CONSENT AND PERMISSION</Heading>
    <Text as="p">
      You may withdraw your consent to submit any or all Personal Information or
      decline to provide any permissions on its Website as covered above at any
      time. In case, you choose to do so then your access to the Website may be
      limited, or we might not be able to provide the services to you. You may
      withdraw your consent by sending an email to{" "}
      <Link href="mailto:admin@quickbusride.in">admin@quickbusride.in</Link>
    </Text>
    <Heading as="h2">J. YOUR RIGHTS QUA PERSONAL INFORMATION</Heading>
    <Text as="p">
      You may access your Personal Information from your user account with{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>
      . You may also correct your personal information or delete such
      information (except some mandatory fields) from your user account
      directly. If you don't have such a user account, then you write to
      <Link href="mailto:admin@quickbusride.in">admin@quickbusride.in</Link>
    </Text>
    <Heading as="h2">
      K. ELIGIBILITY TO TRANSACT WITH{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>
    </Heading>
    <Text as="p">
      We reserve the rights to revise the Privacy Policy from time to time to
      suit various legal, business and customer requirement. We will duly notify
      the users as may be necessary.
    </Text>
    <Heading as="h2">L. CHANGES TO THE PRIVACY POLICY</Heading>
    <Text as="p">
      You must at least 18 years of age to transact directly with{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>
      and also to consent to the processing of your personal data.
    </Text>
    <Text as="p">
      <strong>
        You may always submit concerns regarding this Privacy Policy via email
        to us at{" "}
        <Link href="mailto:admin@quickbusride.in">admin@quickbusride.in</Link>
        .{" "}
        <Link href="https://quickbusride.in">
          <strong>QuickBusRide</strong>
        </Link>{" "}
        shall endeavor to respond to all reasonable concerns and inquiries.
      </strong>
    </Text>
    <Heading as="h2">M. DELETION OF ACCOUNT OR PERSONAL INFORMATION</Heading>
    <Text as="p">
      In case you want to delete your account or your personal information, you
      may write to us at{" "}
      <Link href="mailto:admin@quickbusride.in">admin@quickbusride.in</Link>,
      requesting for deletion of your account. Please note that the DPO may
      require you to verify your identity before proceeding with your request of
      deleting your account. Any identity proof that you may provide shall be
      stored for a period of 21 days from the date of deletion of the account.
    </Text>
    <Text as="p">
      If you do delete the account or personal information, please note that{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>{" "}
      may keep your transactional information, if required as per applicable
      local laws. Further, you may not be able to use the same credentials
      (email ID/mobile number) to create another account with{" "}
      <Link href="https://quickbusride.in">
        <strong>QuickBusRide</strong>
      </Link>{" "}
      for a period of 12 months from the date of deletion of the account.
    </Text>
  </div>
);

export default PrivacyPolicy;
